import { IntranetProject } from '../types';

/**
 * Determine what fields to show based on task type
 * For PROJECT/FALLOUT: Show project dropdown (account is auto-filled from project)
 * For other types: Show account dropdown (no project needed)
 */
export const getTaskTypeFields = (taskType: string) => ({
  showProjectDropdown: ['PROJECT', 'FALLOUT'].includes(taskType),
  showAccountDropdown: ['FIX', 'UPDATE', 'SUPPORT', 'INTERNAL', 'QA', 'CODE_REVIEW'].includes(taskType),
  showWhyField: ['FALLOUT', 'FIX'].includes(taskType),
  showBillingCode: taskType === 'UPDATE',
});

/**
 * Get placeholder text based on task type
 */
export const getDescriptionPlaceholder = (taskType: string): string => {
  switch (taskType) {
    case 'PROJECT':
      return 'Describe the project work...';
    case 'FALLOUT':
      return 'Please describe the FALLOUT in detail. Why was this left out? Who pointed this out?';
    case 'FIX':
      return 'Please describe the FIX in detail. What caused it? What can prevent it in the future?';
    case 'UPDATE':
      return 'Please describe the UPDATE in detail. Who requested it? Did you verbally estimate it, and how much?';
    default:
      return 'What are you working on?';
  }
};

/**
 * Get "Why?" field placeholder based on task type
 */
export const getWhyPlaceholder = (taskType: string): string => {
  if (taskType === 'FALLOUT') {
    return 'Please explain why you consider this FALLOUT, a non billable item.';
  }
  return 'Please explain why you consider this a FIX, a non billable item.';
};

/**
 * Get background color based on task type (matching intranet colors)
 */
export const getTaskTypeColor = (taskType: string): string => {
  switch (taskType) {
    case 'FALLOUT':
    case 'FIX':
      return 'rgba(213, 23, 23, 0.15)'; // Red tint
    case 'UPDATE':
      return 'rgba(83, 206, 9, 0.1)'; // Green tint
    default:
      return 'transparent';
  }
};

/**
 * Get project status color for dropdown styling
 */
export const getProjectStatusColor = (project: IntranetProject): string => {
  switch (project.status) {
    case 'over': return '#ef4444';
    case 'warning': return '#f59e0b';
    case 'caution': return '#eab308';
    case 'good': return '#22c55e';
    case 'internal': return '#06b6d4';
    default: return '#6b7280';
  }
};

